const Vue = require('vue');
const pubsub = require('events/pubsub');
let otherElIdGuid = 0;

const getOtherElId = () => {
	return `scroll-target-${otherElIdGuid++}`;
};

module.exports = {
	bind(el, binding) {
		const otherEl = document.createElement('a');
		const otherElId = binding.value || getOtherElId();
		otherEl.id = otherElId;
		otherEl.classList.add('scroll-target');
		el.dataset.scrollTargetId = otherElId;

		Vue.nextTick(() => {
			el.parentNode.insertBefore(otherEl, el);
		});

		el.unsubscribeScrollTarget = pubsub.subscribe('scroll-target-reset', () => {
			pubsub.publish('scroll-target-ready', otherEl);
			return true;
		});

		pubsub.publish('scroll-target-ready', otherEl);
	},
	unbind(el) {
		const otherEl = document.getElementById(el.dataset.scrollTargetId);
		otherEl.remove();

		if (typeof el.unsubscribeScrollTarget === 'function') {
			el.unsubscribeScrollTarget();
		}
	},
	update(el, { value }) {
		const otherEl = document.getElementById(el.dataset.scrollTargetId);

		if (otherEl) {
			otherEl.id = value;
			el.dataset.scrollTargetId = value;

			pubsub.publish('scroll-target-ready', otherEl);
		}
	}
};
